export default __webpack_public_path__ + "static/audi-iconfont-47158e8d666dfbce1dd344b54751bdcc.woff";